import { Assistant } from "components/assistant";
import BackdropLoading from 'components/common/BackdropLoading';
import DegradedBanner from 'components/organisms/DegradedBanner';
import PageCheckerUnOnboarded from "components/organisms/PageCheckerUnOnboarded";
import { LLMPRoxyServiceProvider } from "contexts/llmProxySerivceContext";
import { PreferencesProvider } from "contexts/preferences-context";
import { UserInformationProvider } from "contexts/userContext";
import { WorkspaceContextProvider } from "contexts/workspace-context";
import AccessRequired from "../layouts/access-required-layout/access-required-layout";
import AuthenticatedLayout from "../layouts/authneticated-layout/authenticated-layout";
import { useUserAuth } from 'hooks/useUserAuth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, RouteProps } from 'react-router-dom';

type Props = {
  protectedRoute?: boolean;
} & RouteProps;

export const PrivateRoute = ({ children, protectedRoute = false, ...rest }: Props) => {
  const { status } = useUserAuth();
  const { t } = useTranslation();
  const { path } = rest;

  const renderAuthenticated = () => (
    <UserInformationProvider>
      <PreferencesProvider>
        <PageCheckerUnOnboarded
          render={() => (
            <WorkspaceContextProvider>
              <LLMPRoxyServiceProvider>
                <div>
                  <AuthenticatedLayout>
                    {protectedRoute ? (
                      <AccessRequired path={path}>{children as any}</AccessRequired>
                    ) : (
                      (children as any)
                    )}
                  </AuthenticatedLayout>
                  <Assistant />
                </div>
              </LLMPRoxyServiceProvider>
            </WorkspaceContextProvider>
          )}
        />
      </PreferencesProvider>
    </UserInformationProvider>
  );

  const renderByStatus = () => {
    switch (status) {
      case 'loading':
        return <BackdropLoading open loadingText={t('common:loading')} />;
      case 'degraded':
        // No access token exists: mount no authenticated providers (getUser must not run).
        return <DegradedBanner />;
      case 'authenticated':
        return renderAuthenticated();
      case 'anonymous':
        return <Redirect to="/sign-in" />;
      default: {
        const unreachable: never = status;
        return unreachable;
      }
    }
  };

  return <Route {...rest} render={renderByStatus} />;
};
